import { deriveStatusBadge } from '@euler/app/components/task-card/utils';
import { TaskListItem } from '@euler/model/TaskListItem';

/** The stages the board counts, named as the task cards' status badge. */
export const kBoardStages = ['预检中', '检测中', '施工中', '待质检'] as const;

export type BoardStage = (typeof kBoardStages)[number];

export function countStages(tasks: TaskListItem[]) {
  const counts = Object.fromEntries(
    kBoardStages.map(stage => [stage, 0]),
  ) as Record<BoardStage, number>;
  for (const task of tasks) {
    const label = deriveStatusBadge(task)?.label;
    if (label && label in counts) counts[label as BoardStage]++;
  }
  return counts;
}
